import { render, staticRenderFns } from "./needsAttentionControl.vue?vue&type=template&id=0b4a8179"
import script from "./needsAttentionControl.vue?vue&type=script&lang=js"
export * from "./needsAttentionControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports